import MobileObjectControllersTable from './MobileObjectControllersTable'

export default MobileObjectControllersTable